import {
  Box,
  Divider,
  Typography
} from '@mui/material';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import React from 'react';
import {SupportTicketModel} from '../../../../model/support/support-ticket.model';
import {SupportTicketUtils} from '../utils/support-ticket.utils';

type Props = {
  ticket: SupportTicketModel
  setTicket: (ticket: SupportTicketModel) => void
  translate: (key: string) => string
  translateLocal: (key: string) => string
  isEditDisabled: boolean
}


export const SupportTicketDrawerAnalysis = ({ticket, setTicket, isEditDisabled, translate, translateLocal}: Props) => {
  const buildHeader = () => (
    <Box mt={1} pt={1}>
      <Box display="flex" alignItems="center" ml={0.5} mb={0.5}>
        <Typography variant="body1" fontWeight={600} letterSpacing={1} mr={1} lineHeight={1}>
          Analiza zgłoszenia:
        </Typography>
      </Box>
      <Divider sx={{ my: 1 }} />
    </Box>
  )

  const buildAnalyzeEstimatedCost = () => <Box mt={2}>
    <TextField
      label={'Estymowany koszt'}
      type={'number'}
      disabled={isEditDisabled}
      value={ticket.analyzeEstimatedCost}
      onChange={(e) => setTicket({...ticket, analyzeEstimatedCost: Number(e.target.value)})}
      required
      fullWidth
    />
  </Box>

  const buildAnalyzeEstimatedDuration = () => <Box mt={2}>
    <TextField
      label={'Estymowany czas realizacji [dni]'}
      type={'number'}
      disabled={isEditDisabled}
      value={ticket.analyzeEstimatedDuration}
      onChange={(e) => setTicket({...ticket, analyzeEstimatedDuration: Number(e.target.value)})}
      required
      fullWidth
    />
  </Box>

  const buildAnalyzeSummary = () =>  <Box mt={3}>
    <TextField
      label={'Podsumowanie analizy'}
      value={ticket.analyzeSummary}
      disabled={isEditDisabled}
      onChange={(e) => setTicket({...ticket, analyzeSummary: e.target.value})}
      required
      multiline
      minRows={5}
      maxRows={5}
      fullWidth
      sx={{
        '& .MuiInputBase-root': {
          overflow: 'auto',
        },
      }}
    />
  </Box>

  return <>
    {buildHeader()}
    <Stack direction="row" spacing={2}>
      <Stack sx={{ flex: 1 }}>{buildAnalyzeEstimatedCost()}</Stack>
      <Stack sx={{ flex: 1 }}>{buildAnalyzeEstimatedDuration()}</Stack>
    </Stack>
    {buildAnalyzeSummary()}
  </>
}